module.exports = __webpack_public_path__ + "img/adhibition-4.923d6d0.png";